import axios from "axios";
import { logoutUser } from "../keycloak/keyCloakConfig";
import config from "../config/index";

// Default - Instance
export const instance = axios.create({
  baseURL: config.moduleApiEndPoint,
  timeout: 15000,

  // headers: { "X-Custom-Header": "foobar" },
});

instance.interceptors.request.use(
  function (config) {
    const token = window.localStorage.getItem("userToken");
    if (token) {
      config.headers["Authorization"] = "Bearer " + token;
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  },
);

instance.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    // Check if the error response exists
    if (error.response) {
      const { status } = error.response;

      if (status === 401 || status === 403) {
        if (true) {
          setTimeout(() => {
            logoutUser();
          }, 2000);
        }
      }
    }

    return Promise.reject(error);
  },
);

// Storage - Instance
export const instanceStorage = axios.create({
  baseURL: config.moduleApiEndPoint,
  timeout: 8000,
});

// Add a request interceptor
instanceStorage.interceptors.request.use(
  function (config) {
    const token = window.localStorage.getItem("userToken");
    if (token) {
      config.headers["Authorization"] = "Bearer " + token;
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  },
);

// Add a response interceptor
instanceStorage.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    return Promise.reject(error);
  },
);

// Upload - Instance
export const instanceUpload = axios.create({
  baseURL: config.moduleApiEndPoint,
  timeout: 60 * 4 * 1000,
});
export const imageconvertInstance = axios.create({
  baseURL: config.nodeContentApiEndPoint,
  timeout: 30000,
});

imageconvertInstance.interceptors.request.use(
  function (config) {
    const token = window.localStorage.getItem("userToken");
    if (token) {
      config.headers["Authorization"] = "Bearer " + token;
      config.headers["x-environment"] = process.env.REACT_APP_ENV;
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  },
);

imageconvertInstance.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    return Promise.reject(error);
  },
);
// Add a request interceptor
instanceUpload.interceptors.request.use(
  function (config) {
    const token = window.localStorage.getItem("userToken");
    //  const token = "12345678dkdklsdf";
    if (token) {
      config.headers["Authorization"] = "Bearer " + token;
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  },
);

// Add a response interceptor
instanceStorage.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    return Promise.reject(error);
  },
);

// ImageConvert - Instance
// export const imageconvertInstance = axios.create({
//   baseURL: config.nodeContentApiEndPoint,
//   timeout: 30000,
// });
// export const imageconvertInstance = axios.create({
//   baseURL: "https://nccabanner-nodeapi-gilead-dev.indegene.com",
//   timeout: 30000,
// });

imageconvertInstance.interceptors.request.use(
  function (config) {
    const token = window.localStorage.getItem("userToken");
    if (token) {
      config.headers["Authorization"] = "Bearer " + token;
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  },
);

imageconvertInstance.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    return Promise.reject(error);
  },
);

export default instance;
